import React from "react";
import { ReactSVG } from "react-svg";
import Rating from "react-rating";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./Reviews.scss";

const data = [
  {
    image: "/images/choose-us-4.jpg",
    title: "Thomas.T",
    rating: 5,
    text: "5.0",
    description: `I have had multiple surgeries on my shoulder in the past and still have not gotten back to full function. I was told by my local surgeon that I would need yet another
    shoulder surgery. This would be my 3rd. I spoke to one of the orthopedic surgeons at
                                      Second Look Ortho after loading all of my imaging and I felt so confident at the end
                                      of my video consultation.`,
  },
  {
    image: "/images/choose-us-2.jpg",
    title: "Ally J.",
    rating: 5,
    text: "5.0",
    description: `I had an MRI done on my knee and was able to look at the written report. I had no
                                      clue what it said. I was referred to an orthopedic specialist but it was going to
                                      take 5 weeks just to get an appointment. One of my
                                      friends told me to look up Second Look Ortho and I was very pleased. I easily
                                      attached the MRI report and picked the phone consultation. `,
  },
  {
    image: "/images/choose-us-1.jpg",
    title: "Maya.",
    rating: 4.8,
    text: "4.8",
    description: `I had an MRI done on my knee and was able to look at the written report. I had no
                                      clue what it said. I was referred to an orthopedic specialist but it was going to
                                      take 5 weeks just to get an appointment. One of my
                                      friends told me to look up Second Look Ortho and I was very pleased. I easily
                                      attached the MRI report and picked the phone consultation. `,
  },
  {
    image: "/images/choose-us-3.jpg",
    title: "Daniel O.",
    rating: "5.0",
    text: "5.0",

    description: `I am an avid mountain bike rider and love the outdoors in general. I enjoy waterskiing, hiking, hunting and in the winter I love skiing. I injured my right shoulder, elbow and knee after a bad fall biking but just avoided going to the doctor’s office because I really don’t have the time. I know this website is for  second opinions but I used it for my first opinion. I just don’t have time to go to the doctor’s office and wait then have them tell me to wait longer to a see a specialist. I signed up with Second Look Ortho and was able to speak with an orthopedic surgeon immediately and tell them what was going on. They gave me great advice and even some exercises to try at home. I was able to get back riding within 6 weeks. This was the best decision for me to keep moving forward and live my life. Thank you `,
  },
];
const Reviews = () => {
  const settings = {
    arrows: true,
    infinite: true,
    dots: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          className: "center",
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="reviews" id="reviews">
      <h2 className="heading-services">What Our Patients Say About Us</h2>
      <div className="about_line"></div>
      <div className="reviews-slider">
        <Slider className="review-slider" {...settings}>
          {data.map((el) => {
            return (
              <div className="review-item-wrapper">
                <div className="review-item">
                  <div className="review-item-top">
                    <img src={el.image}></img>
                    <h4>{el.title}</h4>
                    <div className="rating-div">
                      <h5>{el.rating}</h5>
                      <Rating
                        initialRating={el.rating}
                        readonly
                        emptySymbol={
                          <ReactSVG src="./icons/tools/star-empty.svg" />
                        }
                        fullSymbol={
                          <ReactSVG src="./icons/tools/star-filled.svg" />
                        }
                      />
                    </div>
                  </div>
                  <div className="review-item-bottom">
                    <ReactSVG src="/icons/tools/qoutes.svg" />
                    <p>{el.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default Reviews;
